import type { IShipUser } from "../Types"

export function isShipUser(value: unknown): value is IShipUser {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const row = value as Partial<IShipUser>;
  return typeof row.id === "number"
    && typeof row.shipId === "number"
    && typeof row.shipUserLevel === "number";
}

function sameMembership(left: IShipUser, right: IShipUser): boolean {
  return left.id === right.id
    && left.accountId === right.accountId
    && left.shipId === right.shipId
    && left.userId === right.userId;
}

export function mergeLiveMembership(
  responseMembership: readonly IShipUser[],
  storedMembership: readonly IShipUser[],
): IShipUser[] {
  const merged = responseMembership.map((membership) =>
    storedMembership.find((stored) => sameMembership(stored, membership)) ?? membership);
  for (const stored of storedMembership) {
    if (!merged.some((membership) => sameMembership(membership, stored))) {
      merged.push(stored);
    }
  }
  return merged;
}
